import React from 'react';

export const cloneVacancy = (
  <svg viewBox='0 0 86 96' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.71289 4.50751V66.5283C5.71289 69.0159 7.72835 71.0358 10.2106 71.0358H56.3967C58.8789 71.0358 60.8944 69.0159 60.8944 66.5283V25.7481C60.8944 24.5574 60.4276 23.4093 59.579 22.5588L38.3211 1.31823C37.4725 0.46776 36.3268 0 35.1388 0H10.1894C7.72836 0 5.71289 2.01987 5.71289 4.50751Z'
      fill='#3598DC'
    />
    <path
      d='M2 8.26972V70.2905C2 72.7781 4.01546 74.798 6.49767 74.798H52.6838C55.166 74.798 57.1815 72.7781 57.1815 70.2905V29.5315C57.1815 28.3409 56.7147 27.1927 55.8661 26.3423L34.6294 5.08044C33.7808 4.22997 32.6352 3.76221 31.4471 3.76221H6.49767C4.01546 3.76221 2 5.78208 2 8.26972Z'
      stroke='#3B3F51'
      strokeWidth='3'
      strokeMiterlimit='10'
    />
    <path
      d='M33.2725 4.16699V23.1538C33.2725 25.6414 35.2879 27.6613 37.7702 27.6613H56.7156'
      stroke='#3B3F51'
      strokeWidth='3'
      strokeMiterlimit='10'
    />
    <path
      d='M11.8645 39.6099C11.8645 39.0783 12.31 38.6318 12.8404 38.6318H46.7003C47.2307 38.6318 47.6763 39.0783 47.6763 39.6099C47.6763 40.1414 47.2307 40.5879 46.7003 40.5879H12.8404C12.31 40.5879 11.8645 40.1414 11.8645 39.6099Z'
      fill='white'
    />
    <path
      d='M11.8652 31.6372C11.8652 31.1057 12.3108 30.6592 12.8411 30.6592H26.2918C26.8222 30.6592 27.2677 31.1057 27.2677 31.6372C27.2677 32.1688 26.8222 32.6153 26.2918 32.6153H12.8411C12.3108 32.6153 11.8652 32.1688 11.8652 31.6372Z'
      fill='white'
    />
    <path
      d='M11.8645 47.5835C11.8645 47.052 12.31 46.6055 12.8404 46.6055H46.7003C47.2307 46.6055 47.6763 47.052 47.6763 47.5835C47.6763 48.1151 47.2307 48.5616 46.7003 48.5616H12.8404C12.31 48.5616 11.8645 48.1363 11.8645 47.5835Z'
      fill='white'
    />
    <path
      d='M11.8645 55.5549C11.8645 55.0234 12.31 54.5769 12.8404 54.5769H46.7003C47.2307 54.5769 47.6763 55.0234 47.6763 55.5549C47.6763 56.0865 47.2307 56.533 46.7003 56.533H12.8404C12.31 56.533 11.8645 56.1078 11.8645 55.5549Z'
      fill='white'
    />
    <path
      d='M11.8645 63.5488C11.8645 63.0173 12.31 62.5708 12.8404 62.5708H46.7003C47.2307 62.5708 47.6763 63.0173 47.6763 63.5488C47.6763 64.0804 47.2307 64.5269 46.7003 64.5269H12.8404C12.31 64.5269 11.8645 64.0804 11.8645 63.5488Z'
      fill='white'
    />
    <path
      d='M27.7327 25.4721V87.4929C27.7327 89.9805 29.7482 92.0004 32.2304 92.0004H78.4164C80.8986 92.0004 82.9141 89.9805 82.9141 87.4929V46.7127C82.9141 45.522 82.4474 44.3739 81.5988 43.5234L60.3621 22.2616C59.5135 21.4111 58.3678 20.9434 57.1797 20.9434H32.2304C29.7482 20.9646 27.7327 22.9845 27.7327 25.4721Z'
      fill='white'
    />
    <path d='M59.0042 21.3672V40.354C59.0042 42.8416 61.0196 44.8615 63.5018 44.8615H82.4473' fill='white' />
    <path
      d='M31.4456 21.6887V83.7094C31.4456 86.1971 33.461 88.2169 35.9433 88.2169H82.1294C84.6116 88.2169 86.627 86.1971 86.627 83.7094V42.9505C86.627 41.7598 86.1603 40.6117 85.3117 39.7612L64.0538 18.4994C63.2052 17.6489 62.0595 17.1812 60.8715 17.1812H35.922C33.461 17.1812 31.4456 19.201 31.4456 21.6887Z'
      fill='#C2E0F5'
    />
    <path
      d='M27.7327 25.4721V87.4929C27.7327 89.9805 29.7482 92.0004 32.2304 92.0004H78.4164C80.8986 92.0004 82.9141 89.9805 82.9141 87.4929V46.7127C82.9141 45.522 82.4474 44.3739 81.5987 43.5234L60.3621 22.2616C59.5135 21.4111 58.3678 20.9434 57.1797 20.9434H32.2304C29.7482 20.9646 27.7327 22.9845 27.7327 25.4721Z'
      stroke='#3B3F51'
      strokeWidth='3'
      strokeMiterlimit='10'
    />
    <path
      d='M59.0042 21.3672V40.354C59.0042 42.8416 61.0196 44.8615 63.5018 44.8615H82.4473'
      stroke='#3B3F51'
      strokeWidth='3'
      strokeMiterlimit='10'
    />
    <path
      d='M37.5981 56.7918C37.5981 56.2602 38.0437 55.8137 38.5741 55.8137H72.434C72.9644 55.8137 73.4099 56.2602 73.4099 56.7918C73.4099 57.3233 72.9644 57.7698 72.434 57.7698H38.5741C38.0437 57.7698 37.5981 57.3446 37.5981 56.7918Z'
      fill='#3598DC'
    />
    <path
      d='M37.5974 48.8184C37.5974 48.2868 38.0429 47.8403 38.5733 47.8403H52.0239C52.5543 47.8403 52.9998 48.2868 52.9998 48.8184C52.9998 49.3499 52.5543 49.7964 52.0239 49.7964H38.5733C38.0429 49.7964 37.5974 49.3499 37.5974 48.8184Z'
      fill='#3598DC'
    />
    <path
      d='M37.5981 64.7654C37.5981 64.2339 38.0437 63.7874 38.5741 63.7874H72.434C72.9644 63.7874 73.4099 64.2339 73.4099 64.7654C73.4099 65.2969 72.9644 65.7434 72.434 65.7434H38.5741C38.0437 65.7434 37.5981 65.3182 37.5981 64.7654Z'
      fill='#3598DC'
    />
    <path
      d='M37.5981 72.7593C37.5981 72.2277 38.0437 71.7812 38.5741 71.7812H72.434C72.9644 71.7812 73.4099 72.2277 73.4099 72.7593C73.4099 73.2908 72.9644 73.7373 72.434 73.7373H38.5741C38.0437 73.7373 37.5981 73.2908 37.5981 72.7593Z'
      fill='#3598DC'
    />
    <path
      d='M37.5981 80.7329C37.5981 80.2014 38.0437 79.7549 38.5741 79.7549H72.434C72.9644 79.7549 73.4099 80.2014 73.4099 80.7329C73.4099 81.2645 72.9644 81.711 72.434 81.711H38.5741C38.0437 81.711 37.5981 81.2645 37.5981 80.7329Z'
      fill='#3598DC'
    />
  </svg>
);
